var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMenuHomeGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F89501"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.186 22.993h3.063c.491 0 .891-.335.891-.748v-9.38c.003-.28.236-.505.52-.502h1.406c.458 0 .73-.256.837-.495.116-.256.05-.556-.16-.74l-10.068-9.89c-.341-.334-1.01-.334-1.349 0l-10.07 9.893c-.208.184-.273.484-.16.74.106.24.379.496.836.496h1.264c.287 0 .519.225.519.502v9.38c0 .412.4.747.888.747h3.271v-4.934c.004-.28.236-.505.52-.502h7.27c.286 0 .518.225.518.502l.004 4.93zm3.063 1.004h-3.582c-.284.003-.516-.219-.52-.502v-4.928H8.917v4.931c-.007.283-.24.505-.52.502h-3.79c-1.065 0-1.93-.785-1.93-1.752V13.37h-.744c-.795 0-1.499-.433-1.796-1.106-.273-.632-.13-1.335.38-1.83L10.581.535c.727-.713 2.107-.713 2.834 0l10.07 9.892c.506.499.653 1.199.376 1.83-.294.673-.997 1.11-1.796 1.11h-.884v8.878c0 .966-.868 1.752-1.933 1.752z",
    transform: "translate(-27 -168) translate(23 168) translate(4)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuHomeGray);
export default __webpack_public_path__ + "static/media/ic-menu-home-gray.f237045e081c6581afeea5ebd687ca84.svg";
export { ForwardRef as ReactComponent };